import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const Paperclip = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="17.864" height="18.899" viewBox="0 0 17.864 18.899">
      <path id="paperclip" d="M18.658,9.667l-7.875,7.875a5.144,5.144,0,1,1-7.275-7.275l7.875-7.875a3.429,3.429,0,1,1,4.85,4.85L8.35,15.117a1.715,1.715,0,1,1-2.425-2.425L13.2,5.426" transform="translate(-1.502 -0.649)" fill="none" stroke="#030314" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
    </svg>
  </SvgIcon>
);

export default Paperclip;